import { Component, Input } from '@angular/core';
import { ButtonType } from 'src/app/core/constants/app.enums';

@Component({
    selector: 'app-qbutton',
    templateUrl: './qbutton.component.html',
    styleUrl: './qbutton.component.scss',
    standalone: false
})
export class QButtonComponent {
  @Input() type: ButtonType = ButtonType.Primary;
  @Input() onClick: () => void = () => {};
  
  handleClick() {
    if (this.type !== ButtonType.Disabled) {
      this.onClick();
    }
  }
}